<ng-template #contentShare let-modal class="modal-share p-3">
    <div class="modal-header container border-0 pt-3">

        <button type="button" class="btn-close btn-close-black me-1" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body  p-0">

        <div class="p-3 text-center">
            <h4>PARTAGER LA FICHE DE CE BIEN</h4>

            <div class="social-profiles-widget-bottom">
                <a role="button" href="https://www.facebook.com/sharer.php?u={{share.gfb}}"
                    onclick='window.open(this.href,"popupwindow", "width=800,height=500,left=400,top=150,scrollbars,toolbar=0,resizable"); return false;'
                    class="color-icon-fb-rounded" aria-label="Partager sur Facebook">
                    <img height="80" width="80" src="../../../../../assets/svg/Picto-FB.svg" alt="">
                </a>
                <a role="button" href="https://twitter.com/intent/tweet?url={{share.twLink}}&text={{share.twitterText}}"
                    onclick='window.open(this.href,"popupwindow", "width=800,height=500,left=400,top=150,scrollbars,toolbar=0,resizable"); return false;'
                    class="color-icon-twitter-rounded" aria-label="Partager sur X (Twitter)">
                    <img height="83" width="80" src="../../../../../assets/svg/Picto-Twitter.svg" alt="">
                </a>

                <a role="button"
                    href="https://www.linkedin.com/shareArticle?mini=true&url={{share.gfb}}&title=TheDoorMan&summary={{share.twitterText}}&source=thedoorman.immo"
                    onclick='window.open(this.href,"popupwindow", "width=800,height=500,left=400,top=150,scrollbars,toolbar=0,resizable"); return false;'
                    aria-label="Partager sur LinkedIn">
                    <img height="80" width="80" src="../../../../../assets/svg/Picto-LinkedIn.svg" alt="">
                </a>

                <a role="button" href="https://api.whatsapp.com/send?text={{share.gfb}}"
                    data-action="share/whatsapp/share"
                    onclick='window.open(this.href,"popupwindow", "width=800,height=500,left=400,top=150,scrollbars,toolbar=0,resizable"); return false;'
                    aria-label="Partager sur WhatsApp">
                    <img height="83" width="80" src="../../../../../assets/svg/Picto-Whats_App.svg" alt="">
                </a>
                <a (click)="toogleSendByMail()" role="button" aria-label="Partager par e-mail">
                    <img height="80" width="80" src="../../../../../assets/svg/Picto-email.svg" alt="">
                </a>
            </div>
        </div>

        <div class="bar-bloc text-white">
            <div class="product-desc agenda-page main-bg p-3">
                <div class="title-description white-title">
                    <div class="inner">
                        <div class="title-description text-uppercase">
                            <!--                            <h3 class="white">{{bien.niveau.code_text}} <span *ngIf="bien.property.size_generique">de-->
                            <!--                              {{bien.property.size_generique}}</span> m²-->
                            <!--                            </h3>-->
                            <h3 class="white">{{bien.niveau.code_text}} <span *ngIf="bien.property.size_generique">de
                                    {{bien.property.size_generique}} m²</span> à<br>
                                <span class="accent">{{bien.ville}}</span>
                            </h3>
                        </div>
                        <!--                        <p class="clearfix first-title">-->
                        <!--                              <span style="float: right;" class="float-right ref-title">-->
                        <!--                                Ref :-->
                        <!--                                {{bien?.property.reference}}-->
                        <!--                            </span>-->
                        <!--                        </p>-->
                        <p class="clearfix big-title">
                            <!--                            <span class="white">-->
                            <!--                                <span class="accent">à {{bien.ville}}</span>-->
                            <!--                            </span>-->
                            <span style="float:right" class="float-right price-title">
                              {{bien?.property.price_formatted}}&nbsp;€
                            </span>
                        </p>

                        <!-- <p class="location-title italic-title" *ngIf="!isOffer">
                            {{bien?.property.location ? bien?.property.location : bien?.location}}</p> -->

                        <p class="location-title italic-title"
                            *ngIf="bien?.property?.adresseBien && !bien?.property.adresseBien.codePostalF">
                            {{bien?.property.location ? bien?.property.location : bien?.location}}</p>


                        <div class="details clearfix">
                            <span class="badge-list-item outlined">
                                Ref : {{bien?.numeroMandat}}
                            </span>
                            <svg width="48" height="48" viewBox="0 0 15 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.40446 3.85168H3.08008V6.17606" stroke="#ffffff" stroke-width="0.8"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.18199 11.9871H11.2158V9.95323" stroke="#ffffff" stroke-width="0.8"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.11391 11.9871H3.08008V9.95323" stroke="#ffffff" stroke-width="0.8"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.98555 9.37213L3.08008 11.9871" stroke="#ffffff" stroke-width="0.8"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.18199 3.85168H11.2158V5.88552" stroke="#ffffff" stroke-width="0.8"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.31035 6.46661L11.2158 3.85169" stroke="#ffffff" stroke-width="0.8"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span> {{bien.property.size_generique}} m²</span>
                            <!--                            <span *ngIf="(bien?.property.typeid ? bien?.property.typeid : bien?.typeid) !== 13">-->
                            <!--                                <strong>{{bien?.property.size ? bien?.property.size : bien?.size}}</strong> m²-->
                            <!--                            </span>-->
                            <!--                            <span *ngIf="(bien?.property.typeid ? bien?.property.typeid : bien?.typeid) === 13">-->
                            <!--                                <strong>{{bien?.property.terrain?.surface ? bien?.property.terrain?.surface :-->
                            <!--                                    bien?.terrain?.surface}}</strong> m²-->
                            <!--                            </span>-->
                            <span *ngIf="bien.property.pieces"> <svg width="48" height="48" viewBox="0 0 15 15"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.01309 6.46665V4.14227H1.20215V12.2776H12.2429V4.14227H9.62802"
                                        stroke="#ffffff" stroke-width="0.8" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M4.68848 12.2776L4.68848 7.91937" stroke="#ffffff" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12.2429 8.2099H8.46582" stroke="#ffffff" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                {{bien?.property.pieces ? bien?.property.pieces : bien?.pieces}} Pièce(s)
                            </span>
                            <span *ngIf="(bien?.property.room ? bien?.property.room : bien?.room)">
                                <svg width="48" height="48" viewBox="0 0 25 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.1635 18.388L17.8085 16.2649H4.63487L3.40301 18.3373C3.29432 18.5185 3.01172 18.446 3.01172 18.2286V10.9679C3.01172 10.7651 3.17838 10.5984 3.38127 10.5984H19.178C19.3809 10.5984 19.5475 10.7651 19.5475 10.9679V18.2793C19.5475 18.4895 19.2722 18.5692 19.1635 18.3953V18.388Z"
                                        stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10" />
                                    <path
                                        d="M3.91016 10.5984V5.46811L4.06957 5.42463C8.80134 4.24351 13.7505 4.25075 18.475 5.44637L18.562 5.46811V10.5984"
                                        stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10" />
                                    <path
                                        d="M12.5186 10.5984V9.69263C12.5186 8.48976 13.4968 8.10571 14.6997 8.10571C15.9025 8.10571 16.8808 8.48976 16.8808 9.69263V10.5984"
                                        stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10" />
                                    <path
                                        d="M5.52539 10.5984V9.69263C5.52539 8.48976 6.49638 8.10571 7.69925 8.10571C8.90212 8.10571 9.88035 8.48976 9.88035 9.69263V10.5984"
                                        stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10" />
                                </svg>
                                {{bien?.property.room ? bien?.property.room : bien?.room}}
                                Chambre{{(bien?.property.room ? bien?.property.room : bien?.room) > 1 ? 's' : ''}}
                            </span>
                            <!--                    <span class="right hidden-xs" *ngIf="bien?.property.directVisit">Visite directe-->
                            <!--                        <span class="icon-visite">-->
                            <!--                        <i class="icon-info"-->
                            <!--                           title='Dans le cadre de l’option « visite directe », le propriétaire a choisi de mener lui-même les visites de son bien.-->
                            <!--                           Il accueillera directement les candidats acquéreur pour les visites. En cas de volonté d’acquisition par l’un d’entre eux,-->
                            <!--                           THE DOOR MAN reprendra la main pour la préparation de l’avant contrat jusqu’à la signature authentique finale chez le notaire.'>-->
                            <!--                        </i>-->
                            <!--                        </span>-->
                            <!--                    </span>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-share-mail *ngIf="showSendMail" [bien]="bien"></app-share-mail>
    </div>
</ng-template>
<div *ngIf="!detailBien" class="btn-bien">
  <a role="button" class="w-100 iconClass" (click)="openVertically(contentShare)"
     aria-label="Partager ce bien">
    <fa-icon class="hover-share" [ngStyle]="{color: colorIcon}" [icon]="['fas', 'share-nodes']"></fa-icon>
  </a>
</div>

<a *ngIf="detailBien" role="button" class="w-100 btn-open" (click)="openVertically(contentShare)"
   aria-label="Partager ce bien">
    <fa-icon class="hover-share" [ngStyle]="{color: colorIcon}" [icon]="['fas', 'share-nodes']"></fa-icon>
</a>
